"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retry = retry;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function retry(_x) {
  return _retry.apply(this, arguments);
}
function _retry() {
  _retry = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fn) {
    var retriesLeft,
      interval,
      _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            retriesLeft = _args.length > 1 && _args[1] !== undefined ? _args[1] : 5;
            interval = _args.length > 2 && _args[2] !== undefined ? _args[2] : 1000;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              fn().then(resolve).catch(function (error) {
                setTimeout(function () {
                  if (retriesLeft === 1) {
                    reject(error);
                    return;
                  }
                  retry(fn, retriesLeft - 1, interval).then(resolve, reject);
                }, interval);
              });
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _retry.apply(this, arguments);
}